import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, styled } from '@mui/material';
import React, { useState } from 'react';

import { Exame } from '../../../interfaces/entities/ResultadoExame/Exame';
import { ResultadoExame } from '../../../interfaces/entities/ResultadoExame/ResultadoExame';
import { ExamsTableProps } from '../../../interfaces/props/SaudeOnline/ResultadoExames/ExamsTableProps';
import { sxTable, sxTitleResult } from './sxProps';
import './styles.css';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

const ExamsTable: React.FC<ExamsTableProps> = ({ exames }) => {

  const [showModalResults, setShowModalResults] = useState(false);
  const [results, setResults] = useState<ResultadoExame>();

  const accessibility = useAccessibility();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
      fontFamily: 'Unimed-Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      width: '25%'
    },
    ...accessibility.textStyleAccessibility
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));

  const openHandleResult = (exam: Exame) => {
    setResults(exam.resultadoExame[0]);
    setShowModalResults(true);
  }

  return (
    <div>
      <TableContainer className='container-table-result-exam' sx={sxTable} component={Paper} style={accessibility.contrastBorderAccessibility}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell><b>Título</b></StyledTableCell>
              <StyledTableCell align="left"><b>Demonstrativo</b></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {exames.map((exam) => (
              <StyledTableRow
                tabIndex={0}
                key={exam.descrTUSS}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell component="th" scope="row">
                  {exam.descrTUSS}
                </StyledTableCell>

                <StyledTableCell align="left">
                  <button
                    className='demonstrativo-button'
                    onClick={() => openHandleResult(exam)}
                    style={accessibility.textStyleAccessibility}
                  >
                    Abrir Resultado
                  </button>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={showModalResults}
        onClose={() => { setShowModalResults(false) }}
      >
        <div className='container-modal-results '>
          <div className='container-title-results'>
            <div>
              <Typography sx={sxTitleResult}>{results?.item}</Typography>
            </div>
            <IconButton onClick={() => { setShowModalResults(false) }}>
              <FontAwesomeIcon size='sm' icon={faTimes} />
            </IconButton>
          </div>

          <ul>
            <li className='descr-result'><strong>Data:</strong> {results?.dataHoraLibera}</li>
            <li className='descr-result'><strong>Laboratório Executante:</strong> {results?.descrLabExec}</li>
            <li className='descr-result'><strong>Médico Solicitante:</strong> {results?.nomeMedicoSolicit}</li>
            <li className='descr-result'><strong>CRM:</strong> {results?.crmMedicoSolicit}</li>
            <li className='descr-result'><strong>Data da última atualização:</strong> {results?.dataUltAtualizacao}</li>
            <li className='descr-result'><strong>Metodologia:</strong> {results?.metodol}</li>
            <li className='descr-result'><strong>Valor de Referência:</strong> {`${results?.valorRefer} ${results?.unidMedida}`}</li>
            <li className='descr-result'><strong>Valor:</strong> {`${results?.valor} ${results?.unidMedida}`}</li>
          </ul>
        </div>
      </Modal>
    </div>
  )
}

export default ExamsTable